module.exports = __webpack_public_path__ + "static/media/facesheetImage.44520faa.png";